import { render, staticRenderFns } from "./Promotions.vue?vue&type=template&id=011846be&scoped=true"
import script from "./Promotions.vue?vue&type=script&lang=js"
export * from "./Promotions.vue?vue&type=script&lang=js"
import style0 from "./Promotions.vue?vue&type=style&index=0&id=011846be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011846be",
  null
  
)

export default component.exports